import { MapType } from './libs/map/common'
const endpoint = window.location.protocol + "//" + window.location.host
const config = {
  huali: {
    title: '',
    subTitle: '智能网联运营支撑平台',
    project: {
    },
  },
  nast: {
    title: '',
    subTitle: '智能网联运营支撑平台',
    project: {

    },
  },
  stc: {
    title: '',
    subTitle: '车联网运营管理平台',
    project: {
      position: { longitude: 114.064259, lattitude: 22.672039 }
    },
  },
  url: endpoint,
  baseUrl: 'wp-json/',
  map: MapType.Gaode
}
export default config
